// extracted by mini-css-extract-plugin
export default {"formInput":"YourContact_formInput__kiI5b","inputs":"YourContact_inputs__eY4cP"};